export class Utils{
    constructor (){

    }
}